import React from 'react';
import R from 'common/res/R';
import { DRNCheckbox } from '@traveloka/district-ui';

// temporary wrapper for DRNCheckbox with default color using R.color.brand
// until the DRNCheckbox issues solved
const Checkbox = props => <DRNCheckbox {...props} />;
Checkbox.defaultProps = {
  color: R.color.brand,
};

export default Checkbox;
